import {
  Box,
  buildPath,
  buildTemplatePath,
  newToast,
  Page,
  PageRoute,
  pn,
  useElementBreakpoints,
  useValidationErrors,
} from "@compass/core";
import {
  ObjectiveReportsFilter,
  ObjectiveReportsRequest,
  ObjectiveReportsResource,
  ObjectiveReportsResult,
} from "generated/openApi";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { ObjectiveReportFilter } from "./ObjectiveReportFilter";
import { ObjectiveReportPageHeader } from "./ObjectiveReportPageHeader";
import { ReportResult } from "./ReportResult/ReportResult";

const routeName = "objectiveReport";

export const objectiveReportPageRoute: PageRoute = {
  handle: "Objectives",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export type ScreenType = "config" | "report";

export const ObjectiveReportPage = () => {
  const dispatch = useDispatch();
  const { breakpointsRef } = useElementBreakpoints();
  const { validationErrors, setValidationErrors } = useValidationErrors();
  const [screen, setScreen] = useState<ScreenType>("config");
  const [request, setRequest] = useState<ObjectiveReportsRequest>({} as ObjectiveReportsRequest);
  const [result, setResult] = useState<ObjectiveReportsResult>({});
  const [resource, setResource] = useState<ObjectiveReportsResource>({});

  useEffect(() => {
    getRequest();
    getResource();
  }, []);

  const getRequest = () => {
    ApiService.objectiveReports.get().then((response) => {
      setRequest(response);
    });
  };

  const getResource = () => {
    ApiService.objectiveReports.getResource().then((response) => {
      setResource(response);
    });
  };

  const generateReport = () => {
    ApiService.objectiveReports
      .generateReport(request)
      .then((response) => {
        setResult(response);
        setScreen("report");
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        setValidationErrors(ex.data);
      });
  };

  return (
    <Page
      header={
        <ObjectiveReportPageHeader
          handle={objectiveReportPageRoute.handle}
          screen={screen}
          setScreen={setScreen}
          generateReport={generateReport}
          //setValidationErrors={setValidationErrors}
        />
      }
    >
      <Box ref={breakpointsRef}>
        {screen === "config" && (
          <ObjectiveReportFilter
            filter={request.filter || ({} as ObjectiveReportsFilter)}
            setFilter={(filter) => setRequest({ ...request, filter: filter })}
            validationErrors={validationErrors?.[pn<ObjectiveReportsRequest>("filter")]}
            resource={resource}
          />
        )}

        {screen === "report" && <ReportResult result={result} />}
      </Box>
    </Page>
  );
};
